import { useCallback, useEffect, useRef,useState } from "react";

export default function useDynamicContainerHeight(padding = 20) {
	const containerRef = useRef(null);
	const [containerHeight, setContainerHeight] = useState("");

	const updateHeight = useCallback(() => {
		if (containerRef.current) {
			const yPosition = containerRef.current.getBoundingClientRect().y;
			const windowHeight = window.innerHeight;
			setContainerHeight(`${windowHeight - yPosition - padding}px`);
		} else {
			setContainerHeight("");
		}
	}, [padding]);

	useEffect(() => {
		updateHeight();
		window.addEventListener("resize", updateHeight);
		return () => window.removeEventListener("resize", updateHeight);
	}, [updateHeight]);

	return { containerRef, containerHeight };
}